module.exports = __webpack_public_path__ + "static/img/8en.08d6369.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/8en.png
// module id = eadz
// module chunks = 0